import { createFileRoute } from "@tanstack/react-router";
import ListViewPage from "@/site/pages/list-view";

// A birthday list's page (PRD 16 §6.1 "The list page", the §6.1 owner/member table). Members
// only, full session (D4); a list the member isn't on reads as not found (the API's 404).
interface ListViewSearch {
  /** Just joined: show "You're in. N birthdays were added to your reminders." */
  joined?: boolean;
}

export const Route = createFileRoute("/lists/view/$id")({
  validateSearch: (search: Record<string, unknown>): ListViewSearch =>
    search.joined === true || search.joined === "1" || search.joined === 1 ? { joined: true } : {},
  component: ListViewPage,
});
